import mapFunction from './mapResources';

export default mapFunction('my_group_history', {
    isFetching: false,
    items: []
});